import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmitMemberNewsComponent } from './submit-member-news.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    SubmitMemberNewsComponent
  ],
  imports: [
      CommonModule
      , FormsModule
      , RouterModule
      , ReactiveFormsModule
      , EditorModule
      , NgbTooltipModule
  ]
})
export class MemberNewsModule { }
